import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import Header atau NavigationBar sesuai nama file
import NavigationBar from "./components/Navbar"; 
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import VisiMisi from "./pages/VisiMisi";
import Program from "./pages/Program";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NewsDetail from "./pages/NewsDetail";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <Router>
      <NavigationBar />

      <main className="container mt-4 mb-5">
        <Routes>
          {/* Website */}
          <Route path="/" element={<Home />} />
          <Route path="/tentang" element={<About />} />
          <Route path="/visi-misi" element={<VisiMisi />} />
          <Route path="/program" element={<Program />} />
          <Route path="/galeri" element={<Gallery />} />
          <Route path="/kontak" element={<Contact />} />
          <Route path="/news/:id" element={<NewsDetail />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;